/* eslint-disable react/jsx-filename-extension */
import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledRemainingCredits = styled('div')`
  .remaining-credits-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .label {
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      color: ${COLOR.black.default};
    }
    .remaining-content-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
      .lock-icon {
        color: ${COLOR.red};
        cursor: pointer;
      }
      .content {
        color: ${COLOR.black.default};
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px;
      }
      .tooltip {
        padding: 0px;
      }

      .remaining-credits-container {
        display: flex;
        align-items: center;
        gap: 4px;

        .tooltip-content {
          font-size: 8px;
        }
      }
    }
  }
`;

export const StyledPackageV2 = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 10px;
  .title {
    color: ${COLOR.darkGray};
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
  }

  .remaining-credits-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .icon {
      height: 16px;
      width: 16px;
    }

    .label {
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      color: ${COLOR.black.default};
    }
    .content {
      color: ${COLOR.black.default};
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px;
    }
  }

  .warining-advanced-voice-container {
    display: flex;
    gap: 8px;
    padding: 8px;
    background: rgba(255, 149, 0, 0.08);
    align-items: center;
    border-radius: 8px;

    .warning-text {
      color: ${COLOR.darkGray};
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.4px;
    }
  }
`;
